import React, { useState, useEffect } from 'react';
import { Link } from "gatsby";
import { BLOCKS } from "@contentful/rich-text-types";

import { getToken, getTotalsById } from "../../../services/social.services";

import { ThemeColors } from "../../../data/foro.data.js"

// Styles //
import "./themeCard.scss";

interface ReferenciaSubcategoria {
    slug: string;
    createdAt?: any;
    imagenHeader: {
        file: {
            url: string;
            fileName: string;
        };
    };
    migaDePan?: string;
    tituloMultimedia: string;
    tematica: string;
    textoIntroductorio: string;
    contentful_id: string;
}

const ThemeCard = (props: ReferenciaSubcategoria) => {
    const RenderOptions = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p className="m-theme-card__description__paragraph">{children}</p>;
            }
        },
    };

    let defaultFormValues = {
        ultimaInteraccion: "Jamás",
        respuestas: "0",
        visitas: "0"
    };
    const [metricData, setMetricData] = useState(defaultFormValues);

    useEffect(() => {
        const getTotals = async () => {
            const token = await getToken(null);
            const response = await getTotalsById(props.contentful_id, 2, token);
            const totalsData:any = response.data.data;
            setMetricData(totalsData);
        };
        getTotals();
    }, []);

    const themeColor = ThemeColors[props.tematica];

    return (
        <div className="m-theme-card">
            <Link to={props.slug}>
                {/* <div className="m-theme-card__image">
                    <img src={props.imagenHeader.file.url} alt={props.tematica}/>
                </div> */}
                <div className="m-theme-card__theme" style={{"background": themeColor.bgColor}}>
                    <div className="m-theme-card__theme__text" style={{"color": themeColor.color}}>
                        {props.tematica}
                    </div>
                </div>
                <div className="m-theme-card__content">
                    <div className="m-theme-card__content__description">
                        <h3>{props.tituloMultimedia}</h3>
                        <p>{props.textoIntroductorio}</p>
                    </div>
                </div>
                <div className="m-theme-card__metrics">
                    <div className="m-theme-card__metrics__item">
                        <div className="metricHeader">
                            <strong>Última interacción</strong>
                        </div>
                        <div>
                            {metricData.ultimaInteraccion}
                        </div>
                    </div>
                    <div className="m-theme-card__metrics__item">
                        <div className="metricHeader">
                            <strong>Respuestas</strong>
                        </div>
                        <div>
                            {metricData.respuestas}
                        </div>
                    </div>
                    <div className="m-theme-card__metrics__item">
                        <div className="metricHeader">
                            <strong>Visitas</strong>
                        </div>
                        <div>
                            {metricData.visitas}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    )
}

export default ThemeCard;